import { z } from 'zod';
import { STATIC_MAP_NETWORK } from './helpers/enums.ts';

export const staticMapNetworkSchema = z.enum([...STATIC_MAP_NETWORK, '']);

export const staticMapNetworkRequiredSchema = staticMapNetworkSchema.refine((val) => val !== '', {
  message: 'Choose a network type',
});

export const staticMapNetworkStrictSchema = z.enum(STATIC_MAP_NETWORK);
